import { useMutation, useQuery } from "react-query";
import {
  getDetailsOrganization,
  putUpdateOrganization,
} from "../../../Apis/orgApi/OrgApi";
import { jwtDecode } from "jwt-decode";
import { Card, CardBody, Col, Row } from "reactstrap";
import { FormDataFeild } from "../../../reuseable/Inputs";
import { TYPE_FELDS } from "../../../constants";
import { Button } from "primereact/button";
import {
  SLACE,
  WA_KEYS,
  WHATSAPP_KEYS,
} from "../../../reuseable/Breadcrumb/BreadcrumbConstant";
import Breadcrumb from "../../../reuseable/Breadcrumb/Breadcrumb";
import { useContext, useEffect, useState } from "react";
import WhatsAppKeyContext from "../../../context/WhatsAppKeyContext/WhatsAppKeyContext";
import { ToastMessage } from "../../../utils/Helper";
import Loader from "../../../layouts/loader";

const WhatsAppKeys = () => {
  const { setFormData, setDialogs, formData, dialog, errors, setErrors } =
    useContext(WhatsAppKeyContext);
  const decoded = localStorage.getItem("authToken")
    ? jwtDecode(localStorage.getItem("authToken").replace("Bearer ", ""))
    : "";
  const [isEdit, setIsEdit] = useState(false);
  const { data, isLoading, refetch } = useQuery(
    ["getDetailsOrganizationKey", decoded?.orgId],
    () => getDetailsOrganization(decoded?.orgId),
    {
      enabled: false,
      retry: 3,
      onSuccess: (response) => {
        setFormData({
          wpApiKey: response.wpApiKey,
          wpApiSecret: response.wpApiSecret,
        });
      },
    }
  );

  useEffect(() => {
    if (!isEdit) {
      refetch();
    }
  }, [isEdit, refetch]);

  const handleEdite = () => {
    setIsEdit(true);
  };
  const handleClose = () => {
    setIsEdit(false);
  };

  const handleUserCreateAndUpdate = () => {
    let value = {
      wpApiKey: formData?.wpApiKey,
      wpApiSecret: formData?.wpApiSecret,
    };
    if (decoded?.userId) {
      updateUser(value);
    }
    // handle logic here
  };

  const { mutate: updateUser, isLoading: updateUserLoader } = useMutation(
    (formData) => putUpdateOrganization(formData, decoded?.orgId),
    {
      onSuccess: (response) => {
        try {
          if (response.status === 200) {
            setDialogs(false);
            setIsEdit(false);
            refetch();
            ToastMessage(response.status, response.data.message);
          }
        } catch (error) {
          console.log("error >> ", error);
        }
      },
    }
  );

  const handleChangeOrgAdmin = (e) => {
    const { name, value } = e.target;
    const newFormValues = { ...formData, [name]: value };
    setFormData(newFormValues);
  };

  return (
    <div>
      <Breadcrumb name={WA_KEYS} slace={SLACE} name1={WHATSAPP_KEYS} />
      <Row>
        <Col sm="12">
          <Card>
            {isLoading ? (
              <Loader />
            ) : (
              <CardBody>
                <Row>
                  <Col sm={isEdit ? "12" : "6"}>
                    <Col md="12 mb-4">
                      <FormDataFeild
                        label={"wpApiKey"}
                        name="wpApiKey"
                        id="wpApiKey"
                        type={TYPE_FELDS.text}
                        placeholder={"wpApiKey"}
                        value={formData?.wpApiKey}
                        isValid={false}
                        handleChange={handleChangeOrgAdmin}
                        disabled={!isEdit}
                      />
                    </Col>
                    <Col md="12 mb-4">
                      <FormDataFeild
                        label={"wpApiSecret"}
                        name="wpApiSecret"
                        id="wpApiSecret"
                        type={TYPE_FELDS.text}
                        placeholder={"wpApiSecret"}
                        value={formData?.wpApiSecret}
                        isValid={false}
                        handleChange={handleChangeOrgAdmin}
                        disabled={!isEdit}
                      />
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col md="12 mb-4" className="btn-style ms-2">
                    {isEdit ? (
                      <>
                        <Button
                          label={"Submit"}
                          icon="pi pi-check"
                          // loading={updateUserLoader}
                          type={TYPE_FELDS.button}
                          onClick={handleUserCreateAndUpdate}
                        />
                        <Button
                          label="Close"
                          icon="pi pi-times"
                          className="ms-3"
                          severity="secondary" // ⚪ gray button
                          type={TYPE_FELDS.button}
                          onClick={handleClose} // ideally should close modal, not submit
                        />
                      </>
                    ) : (
                      <Button
                        label={
                          formData?.wpApiSecret && formData?.wpApiKey
                            ? "Edit Keys"
                            : "Add Keys"
                        }
                        icon="pi pi-pencil"
                        onClick={handleEdite}
                        type={TYPE_FELDS.button}
                        loading={updateUserLoader}
                      />
                    )}
                  </Col>
                </Row>
              </CardBody>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default WhatsAppKeys;
